
import {mapState} from "vuex"

import VueDraggableResizable from 'vue-draggable-resizable-gorkys'

export default {
  name: "node",
  props: {
    page: {
      type: Array
    },
    pageBg: {
      type: String
    },
  },
  components: {VueDraggableResizable},
  data() {
    return {
      n: true,
      zoom: 1
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const width = this.$refs.pageItemContent.clientWidth
        const height = this.$refs.pageItemContent.clientHeight
        if (this.width / this.height < width / height) {
          this.zoom = height / this.height
        } else {
          this.zoom = width / this.width
        }



      }, 200)
    })
  },
  methods: {},
  computed: {
    ...mapState({
      isActive: state => state.isActive,
      width: state => state.width,
      height: state => state.height,
    }),
  },
}
